import React, { createContext, useContext, useState } from "react";
import "./Alert.css"
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaTimes, FaExclamationTriangle } from "react-icons/fa";

const AlertContext = createContext();

export function useAlert() {
  return useContext(AlertContext);
}

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState({ open: false, message: "", type: "info" });

  const showAlert = (message, type = "info") => {
    setAlert({ open: true, message, type });
    setTimeout(() => setAlert({ open: false, message: "", type }), 3000);
  };

  const handleClose = () => setAlert({ open: false, message: "", type: alert.type });

  const getIcon = (type) => {
    if (type === "success") return <FaCheckCircle className="alert-icon" color="#22c55e" />;
    if (type === "error") return <FaExclamationCircle className="alert-icon" color="#ef4444" />;
    if (type === "warning") return <FaExclamationTriangle className="alert-icon" color="#f59e42" />;
    return <FaInfoCircle className="alert-icon" color="#2563eb" />;
  };

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      {alert.open && (
        <div className={`custom-alert ${alert.type}`}>
          {getIcon(alert.type)}
          <span className="alert-message">{alert.message}</span>
          <button className="alert-close" onClick={handleClose} aria-label="Close alert">
            <FaTimes />
          </button>
        </div>
      )}
    </AlertContext.Provider>
  );
}
